<template>
  <div class="col-12">
    <div class="textcard">
      <h2>Sneak peak at the dashboard</h2>
    </div>
  </div>
  <div class="col-12">
    <div class="imagecard">
      <img src="https://cdn.proxyscrape.com/img/dashboard_preview.gif" alt="dashboard preview">
    </div>
  </div>
  <div class="col-12" style="margin-bottom: 30px;">
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
